// extracted by mini-css-extract-plugin
module.exports = {"attachment":"AttachmentsCard_attachment__3CgF2"};